import { render, staticRenderFns } from "./user_agee.vue?vue&type=template&id=482fdd74&scoped=true&"
import script from "./user_agee.vue?vue&type=script&lang=js&"
export * from "./user_agee.vue?vue&type=script&lang=js&"
import style0 from "./user_agee.vue?vue&type=style&index=0&id=482fdd74&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482fdd74",
  null
  
)

export default component.exports